export default "__VITE_ASSET__Cechtg_J__"